import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-SidebarInfo",
  "use": "svg-icon-SidebarInfo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-SidebarInfo\"><g fill=\"none\"><path opacity=\".5\" d=\"M0 0h24v24H0z\" /><path d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 8a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1zm0-1.5A1.25 1.25 0 1 0 12 6a1.25 1.25 0 0 0 0 2.5z\" fill=\"#D8D8D8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol